import { render, staticRenderFns } from "./materialintegralrulelist.vue?vue&type=template&id=46a6f6f0&"
import script from "./materialintegralrulelist.vue?vue&type=script&lang=js&"
export * from "./materialintegralrulelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports